import { Crown } from "lucide-react";

export function Avatar({ src, name, size = 48, ring = true, className = "" }) {
  return (
    <div
      className={`rounded-full overflow-hidden flex items-center justify-center shrink-0 bg-gradient-to-br from-mahogany-700 to-mahogany-950 ${ring ? "ring-1 ring-gold/50" : ""} ${className}`}
      style={{ width: size, height: size }}
      data-testid="avatar"
    >
      {src ? (
        <img src={src} alt={name || "Member"} className="w-full h-full object-cover" />
      ) : (
        <Crown size={Math.round(size * 0.42)} className="text-gold" strokeWidth={1.25} />
      )}
    </div>
  );
}

export default Avatar;
